/**React imports */
import React, { useState, useEffect, useCallback, useRef } from 'react'

/** Context imports */
import { useAlert } from '../../../Context/AlertContext'

/** API imports */
import { checkProxyCarts } from '../../../API/generalAPI'

/** MUI imports */
import { Link } from '@mui/material'

/**Custom Component imports */
import Window from '../../Common/Window'
import LoadingModal from '../Loading/LoadingModal'
import { FlexBox, FlexOne } from '../CustomDivs'
import { SuccessButton, ErrorButton } from '../ActionColorButtons'


const ProxyDetails = ({ open, closeModal, handleProxy, selectedUser }) => {
  const alert = useRef(useAlert())

  const [isLoading, setIsLoading] = useState(false)

  const [sessionUserHasActiveCart, setSessionUserHasActiveCart] = useState(false)

  const [targetUserHasActiveCart, setTargetUserHasActiveCart] = useState(false)

    /** Get =>
   * grabs current active cart status of both session and target user with checkProxyCarts() from generalAPI.js
   * determines whether or not additional user interaction is needed with the proxy details modal
   * handles any errors and the loading modal
   */
  const get = useCallback(() => {
    setIsLoading(true)
    checkProxyCarts(selectedUser.id)
      .then((response) => {
        alert.current.postAjaxAlert(response.data.meta[0], 'rdr')
        if (!response.data.meta[0].err) {
          if (!response.data.ttActiveCart[0].sessionUserActive && !response.data.ttActiveCart[0].targetUserActive) {
            handleProxy(false)
            closeModal(false)
          } else {
            setSessionUserHasActiveCart(response.data.ttActiveCart[0].sessionUserActive)
            setTargetUserHasActiveCart(response.data.ttActiveCart[0].targetUserActive)
          }
        }
      })
      .catch((error) => {
        alert.current.errorMessage(error.message)
      })
      .then(() => {
        setIsLoading(false)
      })
  }, [open])

  // /****************************************************************************/
  /**Use Effect */
  useEffect(() => {
    if (open) {
      get()
    }
  }, [get, open])

  // /****************************************************************************/

  /**Rendering */
  return isLoading ? (
    <LoadingModal />
  ) : (
    <Window
      open={open}
      close={() => {
        closeModal(false)
      }}
      title={'Proxy For User'}
    >
      {targetUserHasActiveCart && (
        <div>Do you want to take <span style={{fontWeight: 'bold'}}>{selectedUser?.dispName}'s</span> active cart?</div>
      )}

      {!targetUserHasActiveCart && sessionUserHasActiveCart && (
        <div>
          <span style={{fontWeight: 'bold'}}>{selectedUser?.dispName}</span> does not currently have a cart. Would you still like
          to store off your cart?
        </div>
      )}

      <div style={{marginTop: '5px', marginBottom: '5px'}}>
        (NOTE: Any active cart you have will be stored in <Link href="/mycarts">My Carts</Link>)
        </div>
      <FlexBox>
        <FlexOne />
        <SuccessButton
          type="submit"
          onClick={() => {
            handleProxy(true)
            closeModal(false)
          }}
        >
          Yes
        </SuccessButton>
        <ErrorButton
          onClick={() => {
            handleProxy(false)
            closeModal(false)
          }}
        >
          No
        </ErrorButton>
      </FlexBox>
    </Window>
  )
}

export default ProxyDetails
